import { CreateMessageData, MetaResponseMessages, ResponseMessages } from "@sms/shared/message/message.interface";
import { MessageRepeatedCountData } from "@sms/shared/message/message-repeated-count.interface";
import { ActionCreatorWithPayload, ActionCreatorWithoutPayload, createAction } from "@reduxjs/toolkit";

export const handleCreateMessage: ActionCreatorWithPayload<ResponseMessages> =
  createAction("message/handleCreateMessage");

export const handleUpdateMessage: ActionCreatorWithPayload<ResponseMessages> =
  createAction("message/handleUpdateMessage");

//Set data
export const setInitMetaMessages: ActionCreatorWithPayload<MetaResponseMessages | null> =
  createAction("message/setInitMeta");
export const setInitMessages: ActionCreatorWithPayload<ResponseMessages[] | null> =
  createAction("message/setInitMessages");
export const setMetaMessages: ActionCreatorWithPayload<MetaResponseMessages | null> = createAction("message/setMeata");

export const setMessages: ActionCreatorWithPayload<ResponseMessages[]> = createAction("message/setMessages");

export const setUpdateMessages: ActionCreatorWithPayload<ResponseMessages[] | null> =
  createAction("messages/setUpdateMessages");

export const setMessagesRepeated: ActionCreatorWithPayload<MessageRepeatedCountData[]> =
  createAction("message/setMessagesRepeated");

// Actions
export const resetMessages: ActionCreatorWithoutPayload = createAction<void>("message/reset");
export const clearMessages: ActionCreatorWithoutPayload = createAction<void>("message/clear");

export const getMessagesAction: ActionCreatorWithoutPayload = createAction<void>("message/getMessages");

export const getMessagesNextPageAction: ActionCreatorWithoutPayload = createAction<void>("message/getNextPage");

export const createMessageAction: ActionCreatorWithPayload<CreateMessageData> = createAction("message/createRequest");

export const updateMessageStatusToReadAction: ActionCreatorWithPayload<string> = createAction(
  "message/updateMessageStatusToRead"
);

export const connectedSocketMessage: ActionCreatorWithoutPayload = createAction<void>("message/connectedSocket");
export const reconnectedSocketMessage: ActionCreatorWithoutPayload = createAction<void>("message/reconnectedSocket");
